import { userService } from "../services";
import config from "../config/config";
import axios from "axios";

let toastInstance = null;

export const initializeToast = (toast) => {
  toastInstance = toast;
};

export const VehicleAction = {
  deleteVehicles,
  gettingExistingVehicleAccess,
  addVehicleForAccess,
  fetchVehicleListV6,
  fetchVehicleList,
  fetchVehicleList1,
  saveUser,
  fetchById,
  fetchByIdV2,
  userActiveInactive,
  updateUser,
  updateVehicle,
  vehicleTypeList,
  vtsModelList,
  VehicleRefresh,
  etpOrderFetch,
  VehicleGpsRemove,
  vehicleStatusList,
  addvehicle,
  importKyc,
  viewCertificate,
  getKycList,
  fetchKycInformation,
  saveKyc,
  fetchKycTrail,
  fetchKycApproval,
  approveAllKyc,
  UpdateDeviceVehicle,
  addVehicleWithExcelOrMultiSelect,
  fetcnNewDsaboard,
  vehicleMaintanceList,
  getDashboardStatusData,
  fetchDriverHistory,
  saveFuelCalibration,
  updateVehicleImage,
};

async function addVehicleWithExcelOrMultiSelect(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config"))?.baseUrl}${config.apiName.addVehicleWithExcelOrMultiSelect
      }`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 201) {
      if (toastInstance)
        toastInstance.success("Success", "Vehicle added successfully!");
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to add vehicle",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function fetchKycInformation(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config"))?.baseUrl}${config.apiName.getKycDetails
      }`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to fetch KYC information",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function fetchVehicleListV6(payload) {
  try {
    let data = {
      company: {
        id: payload.companyId,
      },
      number: payload.number,
      imeiNo: payload.imeiNo,
      vehicleType: {
        id: payload.vehicleType,
      },
      driver: {
        name: payload.driver,
      },
      site: {
        id: payload.siteId,
      },
      vendorId: payload.vendorId ? payload.vendorId : "",
      siteIds: payload.siteIds,
      userId: payload.userId,
      onlyGpsVehicle: payload.onlyGpsVehicle,
      allVehicle: payload.allVehicle,
      fuelSensorEnabled: payload.fuelSensorEnabled,
      activeFuelSensor: payload.activeFuelSensor,
      forDropDown: payload.forDropDown,
      kycStatus: payload?.kycStatus,
      getSyncVehicle: payload?.getSyncVehicle,
      pendingActivation: payload.pendingActivation,
      pendingRenewal: payload.pendingRenewal,
    };

    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.VehicleListV6
      }?pageSize=${payload.pageSize}&pageNo=${payload.pageNo}`;

    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance) toastInstance.info("Info", "No Vehicle Available");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function fetchVehicleList(payload) {
  try {
    let data = {
      company: {
        id: payload.companyId,
      },
      number: payload.number,
      imeiNo: payload.imeiNo,
      vehicleType: {
        id: payload.vehicleType,
      },
      driver: {
        name: payload.driver,
      },
      site: {
        id: payload.siteId,
      },
      vendorId: payload.vendorId ? payload.vendorId : "",
      siteIds: payload.siteIds,
      userId: payload.userId,
      onlyGpsVehicle: payload.onlyGpsVehicle,
      allVehicle: payload.allVehicle,
      fuelSensorEnabled: payload.fuelSensorEnabled,
      activeFuelSensor: payload.activeFuelSensor,
      forDropDown: payload.forDropDown,
      kycStatus: payload?.kycStatus,
      getSyncVehicle: payload?.getSyncVehicle,
      pendingActivation: payload.pendingActivation,
      pendingRenewal: payload.pendingRenewal,
    };

    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.VehicleList
      }?pageSize=${payload.pageSize}&pageNo=${payload.pageNo}`;

    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance) toastInstance.info("Info", "No Vehicle Available");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function fetchVehicleList1(payload) {
  try {
    let data = {
      company: {
        id: payload.companyId,
      },
      number: payload.number,
      imeiNo: payload.imeiNo,
      vehicleType: {
        id: payload.vehicleType,
      },
      driver: {
        name: payload.driver,
      },
      site: {
        id: payload.siteId,
      },
      vendorId: payload.vendorId ? payload.vendorId : "",
      siteIds: payload.siteIds,
      userId: payload.userId,
      onlyGpsVehicle: payload.onlyGpsVehicle,
      allVehicle: payload.allVehicle,
      fuelSensorEnabled: payload.fuelSensorEnabled,
      activeFuelSensor: payload.activeFuelSensor,
      forDropDown: payload.forDropDown,
      kycStatus: payload?.kycStatus,
      getSyncVehicle: payload?.getSyncVehicle,
      pendingActivation: payload.pendingActivation,
      pendingRenewal: payload.pendingRenewal,
    };

    const baseUrl = JSON.parse(localStorage.getItem("config"))?.baseUrl;
    let apiEndpoint = `${baseUrl}api/v5/vehicle/all/dashboard?pageSize=${payload.pageSize}&pageNo=${payload.pageNo}`;

    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance) toastInstance.info("Info", "No Vehicle Available");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function updateUser(payload) {
  console.log(payload);
  try {
    const baseUrl = JSON.parse(localStorage.getItem("config"))?.baseUrl;
    let apiEndpoint = `${baseUrl}api/v5/vehicle/update`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (
      (response && response.status == 200) ||
      response.status == 201 ||
      response.status == 208
    ) {
      if (toastInstance)
        toastInstance.success("Success", "Vehicle updated successfully!");
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to update vehicle",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function updateVehicle(payload) {
  try {
    const baseUrl = JSON.parse(localStorage.getItem("config"))?.baseUrl;
    const apiEndpoint = `${baseUrl}api/v5/vehicle/update`;

    const response = await userService.post(apiEndpoint, payload);

    // No response at all (network error, etc.)
    if (!response) {
      toastInstance?.error("Error", "No response from server");
      return null;
    }

    const status = response.status;
    // Some backends put the real status only in the body, so check both
    const bodyStatus = response.data?.status;

    // 208 = duplicate vehicle no. / engine no. / chassis no.
    if (status === 208 || bodyStatus === 208) {
      toastInstance?.warning(
        "Already Exists",
        response.data?.message ||
        "Vehicle No. / Engine No. / Chassis No. already exists",
      );
      return null;
    }

    if (status === 200 || status === 201) {
      toastInstance?.success("Success", "Vehicle updated successfully!");
      return response.data;
    }

    // Any other non-success status (userService.post returns err.response)
    toastInstance?.error(
      "Error",
      response.data?.message || "Failed to update vehicle",
    );
    return null;
  } catch (error) {
    console.log("error", error);
    toastInstance?.error(
      "Error",
      error?.response?.data?.message || "Something went wrong",
    );
    return null;
  }
}

async function saveUser(payload) {
  console.log(payload);
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.AddVehicle
      }`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 201) {
      if (toastInstance)
        toastInstance.success("Success", "Vehicle added successfully!");
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to add vehicle",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function userActiveInactive(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.ActiveVehicle
      }`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      if (toastInstance)
        toastInstance.success(
          "Success",
          `Vehicle ${payload.isActive ? "activated" : "deactivated"} successfully!`,
        );
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to update vehicle status",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function fetchById(payload) {
  try {
    const baseUrl = JSON.parse(localStorage.getItem("config"))?.baseUrl;
    let apiEndpoint = `${baseUrl}api/v5/vehicle/view?id=${payload.userId}&companyId=${payload.companyId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to fetch vehicle details",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function fetchByIdV2(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.VehicleByIdV2
      }?id=${payload.userId}&companyId=${payload.companyId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to fetch vehicle details",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function vehicleTypeList(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.VehicleTypeList
      }`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to fetch vehicle types",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function vtsModelList(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.vtsModelList
      }?companyId=${payload.companyId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response, "jhuhygtg76yt");
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to fetch VTS models",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function vehicleStatusList(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.VehicleStatusList
      }`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      console.log(response.data, "jhgyfgy");
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to fetch vehicle status",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function VehicleRefresh(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.SyncVehicle
      }?vehicleNo=${payload.vehicleNo}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      if (toastInstance)
        toastInstance.success("Success", "Vehicle refreshed successfully!");
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to refresh vehicle",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function VehicleGpsRemove(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.removeGpsFromVehicle
      }?companyId=${payload.companyId}&id=${payload.vehicleId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      if (toastInstance)
        toastInstance.success(
          "Success",
          "GPS removed from vehicle successfully!",
        );
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to remove GPS",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function etpOrderFetch(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.EtpOrder
      }?orderId=${payload.orderId}&companyId=${payload.companyId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to fetch ETP order",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function addVehicleForAccess(payload) {
  try {
    const apiEndpoint =
      JSON.parse(localStorage.getItem("config")).baseUrl +
      config.apiName.vehicleAddForAccess;

    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 201) {
      if (toastInstance)
        toastInstance.success("Success", "Vehicle access added successfully!");
      return response.data;
    } else {
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to add vehicle access",
        );
      return null;
    }
  } catch (err) {
    console.log(err);
    if (toastInstance)
      toastInstance.error(
        "Error",
        err?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function gettingExistingVehicleAccess(payload) {
  try {
    const apiEndpoint =
      JSON.parse(localStorage.getItem("config")).baseUrl +
      config.apiName.existingVehicleAccess;

    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to fetch existing vehicle access",
        );
      return null;
    }
  } catch (err) {
    console.log(err);
    if (toastInstance)
      toastInstance.error(
        "Error",
        err?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function deleteVehicles(payload) {
  try {
    const apiEndpoint =
      JSON.parse(localStorage.getItem("config")).baseUrl +
      config.apiName.deleteVehicles;

    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 201) {
      if (toastInstance)
        toastInstance.success("Success", "Vehicle deleted successfully!");
      return response.data;
    } else {
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to delete vehicle",
        );
      return null;
    }
  } catch (err) {
    console.log(err);
    if (toastInstance)
      toastInstance.error(
        "Error",
        err?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function addvehicle(payload) {
  try {
    const baseUrl = JSON.parse(localStorage.getItem("config"))?.baseUrl;
    let apiEndpoint = `${baseUrl}api/v5/vehicle/add`;

    let response = await userService.post(apiEndpoint, payload);
    if (response && (response.status == 200 || response.status == 201)) {
      if (toastInstance)
        toastInstance.success("Success", "Vehicle added successfully!");
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to add vehicle",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function importKyc(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.importKycExcel
      }`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && (response.status == 200 || response.status == 201)) {
      if (toastInstance)
        toastInstance.success("Success", "KYC imported successfully!");
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to import KYC",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function viewCertificate(payload) {
  debugger;
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.certificatedata
      }?certificateNo=${payload.certificate ? payload.certificate : null
      }&hostName=${payload.hostName}`;

    let response = await axios.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to view certificate",
        );
      return null;
    }
  } catch (error) {
    if (toastInstance)
      toastInstance.error("Error", error?.message || "Something went wrong");
    console.log("error", error);
    return null;
  }
}

async function getKycList(payload) {
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config"))?.baseUrl
      }${config.apiName.getKycTypes}`;

    let response = await userService.get(apiEndPoint);

    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to fetch KYC list",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function saveKyc(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config"))?.baseUrl}${config.apiName.saveKyc
      }`;

    let response = await userService.post(apiEndpoint, payload);

    if (response && (response.status == 200 || response.status == 201)) {
      if (toastInstance)
        toastInstance.success("Success", "KYC saved successfully!");
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to save KYC",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function fetchKycTrail(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config"))?.baseUrl}${config.apiName.getTrail
      }`;

    let response = await userService.post(apiEndpoint, payload);

    if (response && (response.status == 200 || response.status == 201)) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to fetch KYC trail",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function fetchKycApproval(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config"))?.baseUrl}${config.apiName.kycApproval
      }`;

    let response = await userService.post(apiEndpoint, payload);

    if (response && (response.status == 200 || response.status == 201)) {
      if (toastInstance)
        toastInstance.success(
          "Success",
          "KYC approval processed successfully!",
        );
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to process KYC approval",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function approveAllKyc(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config"))?.baseUrl}${config.apiName.kycAllApprove
      }`;

    let response = await userService.post(apiEndpoint, payload);

    if (response && (response.status == 200 || response.status == 201)) {
      if (toastInstance)
        toastInstance.success("Success", "All KYC approved successfully!");
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to approve all KYC",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function UpdateDeviceVehicle(payload) {
  try {
    const apiEndPoint = `${"https://command.nyggs.com/backend"}`;
    const response = await userService.post(apiEndPoint, payload);
    if (response) {
      if (toastInstance)
        toastInstance.success(
          "Success",
          "Device vehicle updated successfully!",
        );
      return response.data;
    } else {
      if (toastInstance)
        toastInstance.error("Error", "Failed to update device vehicle");
      return null;
    }
  } catch (error) {
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function fetcnNewDsaboard(payload) {
  try {
    const configData = JSON.parse(localStorage.getItem("config"));

    let apiEndPoint = `${configData?.baseUrl}${config.apiName.newDashboardData}?userId=${payload.userId}&userType=${payload.userType}&companyId=${payload.companyId}&type=${payload.status}&engineImmboliser=${payload.engineImmboliser || ""}
&isParked=${payload.isParked ?? ""}&isOperational=${payload.isOperational ?? ""}&isTripNow=${payload.isTripNow ?? ""}&isRelayEnabled=${payload.isRelay ?? ""}&vehicleTypeId=${payload.vehicleTypeId ?? ""}`;

    if (payload.gpsId) {
      apiEndPoint += `&model=${payload.gpsId}`;
    }

    let response = await userService.get(apiEndPoint);

    if (response.data !== null) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to fetch dashboard data",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function getDashboardStatusData(payload) {
  try {
    // const apiEndPoint = `${
    let apiEndPoint = `${JSON.parse(localStorage.getItem("config"))?.baseUrl
      }${config.apiName.newDashboardCountUrl}?userId=${payload.userId}&userType=${payload.userType
      }&companyId=${payload.companyId}&engineImmboliser=${payload.engineImmboliser || ""}
&isParked=${payload.isParked ?? ""}&isOperational=${payload.isOperational ?? ""}&isTripNow=${payload.isTripNow ?? ""}&isRelayEnabled=${payload.isRelay ?? ""}`;
    if (payload.gpsId) {
      apiEndPoint += `&model=${payload.gpsId}`;
    }
    let response = await userService.get(apiEndPoint);

    if (response.data !== null) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to fetch dashboard status",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function vehicleMaintanceList(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.maintenanceVehicleList
      }`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to fetch maintenance list",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function fetchDriverHistory(vehicleId) {
  try {
    const baseUrl = JSON.parse(localStorage.getItem("config"))?.baseUrl;
    const apiEndpoint = `${baseUrl}api/v2/vehicles/${vehicleId}/history`;
    const response = await userService.get(apiEndpoint);
    if (response && response.status === 200) {
      return Array.isArray(response.data) ? response.data : [];
    }
    return [];
  } catch (error) {
    console.error("VehicleAction.fetchDriverHistory error:", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Failed to fetch driver history",
      );
    return [];
  }
}

async function saveFuelCalibration(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config"))?.baseUrl}${config.apiName.saveFuelCalibration
      }`;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      if (toastInstance)
        toastInstance.success(
          "Saved",
          "Fuel calibration values saved successfully",
        );
      return response.data;
    } else {
      console.log(response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to save calibration values",
        );
      return null;
    }
  } catch (error) {
    console.log("error", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}

async function updateVehicleImage(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config"))?.baseUrl}${config.apiName.updateVehicleImage
      }`;
    let response = await userService.post(apiEndpoint, payload);
    if (response && (response.status === 200 || response.status === 201)) {
      return response.data;
    } else {
      console.log("updateVehicleImage failed:", response);
      if (toastInstance)
        toastInstance.error(
          "Error",
          response?.data?.message || "Failed to update vehicle image",
        );
      return null;
    }
  } catch (error) {
    console.log("updateVehicleImage error:", error);
    if (toastInstance)
      toastInstance.error(
        "Error",
        error?.response?.data?.message || "Something went wrong",
      );
    return null;
  }
}